<template>
  <div id="jsonEditComponent">
    <!-- json编辑框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="show"
      width="96%"
      top="2vh"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-dialog
        title="代码修改对比"
        :visible.sync="innerDialogVisibility"
        append-to-body
        width="90%"
        top="4vh"
      >
        <div class="compare-container">
          <my-diff2-html :diff-data="diffData" />
        </div>
      </el-dialog>
      <!-- json 编辑器 -->
      <template>
        <editor-container
          ref="editorContainer"
          :json="json"
          :mode="mode"
          :json-data="jsonData"
          @editor-ready="handleEditorReady"
          @update:json-data="handleJsonDataUpdate"
          @json-change="handleJsonChange"
          @expression-editor-open="handleExpressionEditorOpen"
          @expression-editor-close="handleExpressionEditorClose"
        />
        <div slot="footer" class="dialog-footer" v-if="isShowBottomButton">
          <el-button @click="cancel" :disabled="isExpressionEditorOpen">取 消</el-button>
          <el-button @click="copyText" type="info" :disabled="isExpressionEditorOpen">复 制</el-button>
          <el-button type="primary" @click="openDiff" v-if="type === 'diff'" :disabled="isExpressionEditorOpen">
            对比当前版本
          </el-button>
          <el-button 
            type="primary" 
            @click="submit" 
            :disabled="isExpressionEditorOpen"
            v-if="['edit', 'diff'].includes(type)"
          >
            保 存
          </el-button>
        </div>
      </template>
    </el-dialog>
    <!-- js editor -->
  </div>
</template>

<script>
import { copyText } from '@/utils/util';
import EditorContainer from './EditorContainer.vue';
import MyDiff2Html from '@/components/diff2Html/index.vue';

export default {
  components: {
    // AwesomeEditor: () => import('../awesomeEditor'),
    EditorContainer,
    MyDiff2Html,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'view',
    },
    mode: {
      type: String,
      default: 'code',
    },
    json: {
      type: String,
      default: '',
    },
    oldJson: {
      type: String,
      default: '',
    },
    showJson: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String,
      default: '',
    },
    isShowBottomButton: {
      type: Boolean,
      default: true,
    },
  },
  data: () => {
    return {
      innerDialogVisibility: false,
      editor: null, // 编辑器对象
      jsonData: `{}`,
      isExpressionEditorOpen: false, // 表达式编辑器是否打开
      diffData: [], // diff 数据数组
    };
  },
  computed: {
    show: {
      get() {
        return this.showJson;
      },
      set(value) {
        if (!value) {
          this.cancel();
          // this.$nextTick(() => {
          //   this.showDiff = false;
          // });
        }
      },
    },
    dialogTitle() {
      switch (this.type) {
        case 'view':
          return `导出JSON: ${this.title}`;
        case 'edit':
          return `导入JSON: ${this.title}`;
        case 'diff':
          return `布局JSON: ${this.title}`;
      }
      return `导出JSON: ${this.title}`;
    },
    oldStr() {
      let data = this.oldJson;
      try {
        data = this.json ? JSON.stringify(JSON.parse(this.oldJson), null, '\t') : data;
      } catch (err) {
        console.log(err);
      }
      return data;
    },
    newStr() {
      try {
        return JSON.stringify(JSON.parse(this.jsonData), null, '\t');
      } catch (err) {
        console.log(err);
        return this.jsonData;
      }
    },
  },
  created() {
    this.jsonData = this.json || '{}';
  },
  mounted() {
    // 编辑器初始化逻辑已移至 EditorContainer 组件
  },
  beforeDestroy() {
    // 清理逻辑已移至 EditorContainer 组件
  },
  methods: {
    // 处理编辑器准备就绪事件
    handleEditorReady(editor) {
      this.editor = editor;
    },
    // 处理JSON数据更新事件
    handleJsonDataUpdate(jsonData) {
      this.jsonData = jsonData;
    },
    // 处理JSON变更事件
    handleJsonChange(jsonData) {
      this.jsonData = jsonData;
    },
    // 处理表达式编辑器打开事件
    handleExpressionEditorOpen() {
      this.isExpressionEditorOpen = true;
    },
    // 处理表达式编辑器关闭事件
    handleExpressionEditorClose() {
      this.isExpressionEditorOpen = false;
    },
    format(back) {
      try {
        if (this.editor) {
          this.jsonData = JSON.stringify(this.editor.get());
        }
        if ([`""`].includes(this.jsonData)) {
          return this.$message.error('json格式错误');
        }
        back && back();
      } catch (err) {
        console.log(err);
        this.$message.error('json格式错误');
      }
    },
    copyText() {
      copyText(this.editor.getText(), (val) => {
        if (val) {
          this.$message({
            message: '复制成功',
            type: 'success',
          });
          return;
        }
        this.$message.error('复制失败, 请重试');
      });
    },
    submit() {
      this.format(() => {
        try {
          const json = JSON.parse(this.jsonData);
          this.$emit('save', JSON.stringify(json, null, '\t'));
        } catch (e) {
          console.log(e);
        }
      });
    },
    async openDiff() {
      this.format(async () => {
        if (this.oldStr === this.newStr) {
          this.$message('无差异');
          return;
        }
        // 组装 diffData 数组
        this.diffData = [
          {
            from: this.oldStr,
            to: this.newStr,
            fileName: '布局变更',
          },
        ];
        this.innerDialogVisibility = true;
      });
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
// 设置 dialog body 的上下内边距为 10px
::v-deep .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 10px;
}


.compare-container {
  width: auto;
  position: relative;
}

</style>
